import { useState } from 'react'
import { useToasts } from 'react-toast-notifications'
import useCheckMessageEditable from 'src/feed/EditChatMessage/useCheckMessageEditable'
import { EditingMessage } from './types'

export const usePatientChatEditing = () => {
  const { addToast } = useToasts()
  const [editing, setEditing] = useState<EditingMessage | null>(null)

  useCheckMessageEditable(editing?.createdAt, (newEnough) => {
    if (!newEnough && editing) {
      setEditing(null)
      addToast(
        'Messages can only be edited for 5 minutes after sending. If you want, it can be sent as a new message.',
        { appearance: 'info', autoDismiss: false }
      )
    }
  })

  return [editing, setEditing] as const
}
